import { compact, uniqBy } from "lodash-es";
import { Segment } from "src/types";
import { VARIATION_VARIABLE } from "src/config";
import { TFunction } from "react-i18next";

export function propertyValue(
  segments: Segment[],
  property: keyof Pick<Segment, "roadType" | "height_m" | "speed_km_h" | "ifdmTimeFactor">
) {
  const allValues = uniqBy(segments, property);
  if (allValues.length === 1) return allValues[0][property];
  else return VARIATION_VARIABLE;
}

export function helperTextValueWithOptions(
  segments: Segment[],
  property: keyof Pick<Segment, "ifdmTimeFactorOld" | "roadTypeOld">,
  options: { value: string; label: string }[],
  t: TFunction
) {
  const allValues = uniqBy(segments, property);
  if (allValues.length === 1) {
    const value = allValues[0][property];
    const option = options.find((o) => o.value === value);
    if (option) return t("label.initialValue", { value: option.label });
  }
  return t("label.initialValue", { value: VARIATION_VARIABLE });
}

export function helperTextValue(
  segments: Segment[],
  property: keyof Pick<Segment, "roadTypeOld" | "heightOld_m" | "speedOld_km_h" | "ifdmTimeFactorOld">,
  t: TFunction
) {
  const allValues = uniqBy(segments, property);

  if (allValues.length === 1) {
    if (property === "roadTypeOld")
      return t("label.initialValue", { value: t(`label.roadTypeDict.${segments[0][property]}`) });
    return t("label.initialValue", { value: allValues[0][property] });
  }
  return t("label.initialValue", { value: VARIATION_VARIABLE });
}

export function propertyVehicleCountsValue(segments: Segment[], vehicleType: string) {
  const vehicleCounts = compact(
    segments.map((segment) => segment.vehicleCounts.find((v) => v.vehicleType === vehicleType))
  );
  const allValues = uniqBy(vehicleCounts, "count");
  if (allValues.length === 1) return allValues[0].count;
  else return VARIATION_VARIABLE;
}

export function helperTextVehicleCountsValue(segments: Segment[], vehicleType: string, t: TFunction) {
  const vehicleCounts = compact(
    segments.map((segment) => (segment.vehicleCountsOld || []).find((v) => v.vehicleType === vehicleType))
  );
  const allValues = uniqBy(vehicleCounts, "count");
  if (allValues.length === 1) return t("label.initialValue", { value: allValues[0].count });
  else return t("label.initialValue", { value: VARIATION_VARIABLE });
}
